import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import S3 from 'aws-sdk/clients/s3';

@Injectable({
  providedIn: 'root'
})
export class ContentDownloadService {

  constructor() { }

  videoDownload(video_uri: string) {
    const bucket = new S3(
      {
        accessKeyId: environment.accessKeyId,
        secretAccessKey: environment.secretAccessKey,
        region: environment.region,
      }
    );
    const params = {
      Bucket: environment.contentBucket,
      Key: video_uri
    };
    var url = bucket.getSignedUrl('getObject', params);
    return url
  }
}



